module.exports = __webpack_public_path__ + "static/media/screenshot(26).37101ee2.jpg";